import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/globals.css";
import LandingPage from "@/features/landing/views/landing-view";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <LandingPage />
  </StrictMode>
);
